import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import expertiseTheme from './theme/expertiseTheme';
import PagamentosPage from './pages/PagamentosPage';
import LoginPage from './pages/LoginPage';
import ConfirmEmailPage from './pages/ConfirmEmailPage';
import HomePage from './pages/HomePage';
import ConfiguracoesPage from './pages/ConfiguracoesPage';
import TranscricaoPage from './pages/TranscricaoPage';
import AuthGuard from './components/AuthGuard';
import { AuthProvider } from './contexts/AuthContext';

function App() {
  return (
    <ThemeProvider theme={expertiseTheme}>
      <CssBaseline />
      <AuthProvider>
        <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/confirm-email" element={<ConfirmEmailPage />} />
          
          {/* Protected Routes */}
          <Route
            path="/home"
            element={
              <AuthGuard>
                <HomePage />
              </AuthGuard>
            }
          />
          <Route
            path="/transcricao"
            element={
              <AuthGuard>
                <TranscricaoPage />
              </AuthGuard>
            }
          />
          <Route
            path="/financeiro/pagamentos"
            element={
              <AuthGuard requiredSector="Financeiro">
                <PagamentosPage />
              </AuthGuard>
            }
          />
          <Route
            path="/configuracoes"
            element={
              <AuthGuard>
                <ConfiguracoesPage />
              </AuthGuard>
            }
          />
          
          {/* Redirects */}
          <Route path="/" element={<Navigate to="/home" replace />} />
          <Route path="/financeiro" element={<Navigate to="/financeiro/pagamentos" replace />} />
          <Route path="*" element={<Navigate to="/home" replace />} />
        </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
